import escapeTextContentForBrowser from "escape-html";
import z from "zod";

import avatarMissing from "@/assets/images/placeholders/avatar-missing.png";
import headerMissing from "@/assets/images/placeholders/header-missing.png";
import { unescapeHTML } from "@/utils/html";

import { customEmojiSchema } from "./custom-emoji";
import { groupRelationshipSchema } from "./group-relationship";
import { groupTagSchema } from "./group-tag";
import { dateSchema, filteredArray } from "./utils";

const groupSchema = z
  .object({
    avatar: z.string().catch(avatarMissing),
    avatar_static: z.string().catch(""),
    created_at: dateSchema,
    deleted_at: dateSchema.nullish().catch(null),
    display_name: z.string().catch(""),
    domain: z.string().catch(""),
    emojis: filteredArray(customEmojiSchema),
    group_visibility: z.string().catch(""), // TruthSocial
    header: z.string().catch(headerMissing),
    header_static: z.string().catch(""),
    id: z.coerce.string(),
    locked: z.boolean().catch(false),
    membership_required: z.boolean().catch(false),
    member_avatars: z
      .array(
        z.object({
          id: z.string(),
          username: z.string(),
          avatar: z.string(),
          avatar_static: z.string(),
        }),
      )
      .catch([]),
    members_count: z.number().catch(0),
    owner: z.object({ id: z.string() }).nullable().catch(null),
    note: z
      .string()
      .transform((note) => (note === "<p></p>" ? "" : note))
      .catch(""),
    relationship: groupRelationshipSchema.nullable().catch(null), // Dummy field to be overwritten later
    slug: z.string().catch(""), // TruthSocial
    source: z
      .object({
        note: z.string(),
      })
      .optional(), // TruthSocial
    statuses_visibility: z.string().catch("public"),
    tags: z.array(groupTagSchema).catch([]),
    uri: z.string().catch(""),
    url: z.string().catch(""),
    event_category_name: z.string().nullable().catch(null),
  })
  .transform((group) => {
    group.avatar_static = group.avatar_static || group.avatar;
    group.header_static = group.header_static || group.header;

    return {
      ...group,
      display_name_html: escapeTextContentForBrowser(group.display_name),
      note_emojified: group.note,
      note_plain: group.source?.note || unescapeHTML(group.note),
    };
  });

type Group = z.infer<typeof groupSchema>;

export { groupSchema, type Group };
